import { Injectable } from '@angular/core';
import { WebservicesService } from '../webservices/webservices.service';
import { ConfigService } from '../config/config.service';
import { stringToNumber } from '../codeUtils';

@Injectable({
  providedIn: 'root'
})
export class JackpotserviceService {

  protected jackpot_game_vendors = new Map();
  protected timeIntervals = stringToNumber(this.config.getConfig().FEATURE_JACKPOT_UPDATE_FREQUENCY) ?? 120; // seconds
  private timeOutIntervals;
  private vendorList = [];

  constructor(protected webservices: WebservicesService, protected config: ConfigService) {
    this.checkCountDown();
  }

  private checkCountDown() {
    this.clearTimeoutIntervals();
    if (this.jackpot_game_vendors.size > 0) {
      this.timeOutIntervals = setInterval(() => {
        this.checkVendorTimeClear();
      }, 1000);
    }
  }

  private clearTimeoutIntervals() {
    if (this.timeOutIntervals) {
      clearInterval(this.timeOutIntervals);
    }
  }

  protected checkVendorTimeClear() {
    const currentTime = Date.now();
    this.jackpot_game_vendors.forEach((values, keys) => {
      const clearTime = new Date(values.clearTime).getTime();
      if (clearTime < currentTime) {
        this.jackpot_game_vendors.delete(keys);
        // this.fetchJackpot(keys);
      }
    });
  }

  public removeVendorFromCache(vendor){
    this.jackpot_game_vendors.delete(vendor);
  }

  protected async fetchJackpot(vendor: string): Promise<{ payload: [JackpotView]; clearTime: Date } | null> {
    return new Promise(async (resolve) => {
      const data = {
        vendor: vendor,
        clientapp: this.config.getClientApp(),
      };
      const currentTime = new Date();
      const clearTime = new Date(currentTime);
      clearTime.setSeconds(currentTime.getSeconds() + this.timeIntervals);
      if (!this.vendorOnProgress(vendor)) {
        this.webservices.get('external/jackpot-by-vendor-v2', data, true).subscribe((httpResp) => {
          this.removeVendor(vendor);
          if (httpResp.payload !== undefined && httpResp.result === 1) {
            this.jackpot_game_vendors.set(vendor, { payload: httpResp.payload, clearTime: clearTime });
            resolve(this.jackpot_game_vendors.get(vendor));
          } else {
            resolve(null);
          }
          this.checkCountDown();
        }, (error) => {
          this.removeVendor(vendor);
          resolve(null);
        });
      } else {
        await this.checkVendorIsLoaded(vendor);
        resolve(this.jackpot_game_vendors.get(vendor)?.payload || null);
      }
    });
  }

  protected async checkVendorIsLoaded(vendor: any): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      let tries = 0;
      const maxTries = 10;
      const timeInterval = setInterval(() => {
        const isVendorAvailable = this.jackpot_game_vendors.has(vendor);
        tries++;
        if (isVendorAvailable || tries >= maxTries) {
          clearInterval(timeInterval);
          resolve(isVendorAvailable);
        }
      }, 1000);
    });
  }

  protected removeVendor(vendor) {
    let indexToRemove = this.vendorList.indexOf(vendor);
    if (indexToRemove !== -1) {
      this.vendorList.splice(indexToRemove, 1);
    }
  }

  protected vendorOnProgress(vendor) {
    const isVendorInProess = this.vendorList.some((v) => v == vendor);
    if (!isVendorInProess) this.vendorList.push(vendor);
    return isVendorInProess;
  }

  public async getVendorResponse(vendor: string): Promise<[JackpotView] | null> {
    return new Promise(async (resolve) => {
      if (this.jackpot_game_vendors.has(vendor)) {
        resolve(this.jackpot_game_vendors.get(vendor)?.payload || null);
      } else {
        try {
          await this.fetchJackpot(vendor);
          resolve(this.jackpot_game_vendors.get(vendor)?.payload || null);
        } catch (error) {
          resolve(null);
        }
      }
    });
  }
}


export interface JackpotView {
  balance?: string,
  game?: Game
}

export interface Game {
  vendor?: string
  extGameType?: string
  id?: number
  name?: string
  vendor_name?: string
  game_type_id?: string
  super_type?: string
  rtp?: string
}
